import { Component, input } from '@angular/core';
import type { OnyxRouteLegType, OnyxScheduleCompliance } from '@onyx/angular';
import { OrderPointStatus } from '../../../../../dashboard/orders/common/enums/order-point-status';

@Component({
  selector: 'app-route-point-leg-line',
  imports: [],
  templateUrl: './route-point-leg-line.component.html',
  styleUrl: './route-point-leg-line.component.scss',
  host: {
    '[class]': `[compliance(), type()]`,
    '[class.completed]': `status() === OrderPointStatus.COMPLETED`,
    '[class.empty]': `isEmpty()`,
  },
})
export class RoutePointLegLineComponent {
  public readonly status = input.required<OrderPointStatus>();
  public readonly compliance = input.required<OnyxScheduleCompliance | null>();
  public readonly isEmpty = input.required<boolean>();
  public readonly type = input<OnyxRouteLegType>();

  protected readonly OrderPointStatus = OrderPointStatus;
}
